import { Fab, SxProps, Theme } from "@mui/material";
import { useDarkModeTheme } from "hooks/useDarkmodeTheme";

interface CustomFabProps {
  ariaLabel: string;
  onClick?: () => void;
  disabled?: boolean;
  children: JSX.Element;
  sx?: SxProps<Theme>;
}
export const CustomFab = ({
  children,
  disabled = false,
  onClick,
  sx,
}: CustomFabProps) => {
  const { brandThemeColor } = useDarkModeTheme();
  return (
    <Fab
      onClick={onClick}
      disabled={disabled}
      color="primary"
      variant="extended"
      aria-label="search studies"
      sx={sx}
      //sx={{
      //  background: brandThemeColor,
      //  color: "white",
      //  "&:hover": {
      //    color: "black",
      //  },
      //}}
    >
      {children}
    </Fab>
  );
};
